<template>
  <div class="box">
    <div class="main">
      <van-steps :active="active">
        <van-step>输入信息</van-step>
        <!-- <van-step>人脸核身</van-step> -->
        <van-step>操作完成</van-step>
      </van-steps>
      <!-- <div class="display step">
        <div class="display active">
          <div class="num">1</div>
          <div class="title">输入信息</div>
        </div>
        <div class="line"></div>
        <div class="display">
          <div class="num">2</div>
          <div>人脸核身</div>
        </div>
        <div class="line"></div>
        <div class="display">
          <div class="num">3</div>
          <div>操作完成</div>
        </div>
      </div> -->
      <!-- <div class="idcode">
        <div class>
          <h3>快速录入</h3>
          <p>上传身份证正面照片</p>
          <p>无照片可在下方填写信息录入</p>
        </div>
        <van-uploader v-model="fileList" :after-read="afterRead" :max-count="1">
        <img src="../../assets/upidcode.png" v-if="!fileList.length" />
        </van-uploader>
      </div> -->
      <div class="form">
        <van-form validate-first @failed="onFailed">
          <!-- 通过 pattern 进行正则校验 -->
          <van-field
            v-model="commitData.patientName"
            label="姓名"
            placeholder="请输入姓名"
          />
          <van-field
            v-model="commitData.documentType"
            label="证件类型"
            :readonly="true"
            placeholder="请选择证件类型"
            @click="openSelect"
          />
          <van-field
            v-model="commitData.idCard"
            label="证件号码"
            placeholder="请输入证件号码"
          />
          <van-field
            v-model="commitData.phoneNumber"
            label="手机号码"
            placeholder="请输入手机号码"
          />
          <!-- :rules="[{ pattern, message: '请输入正确的手机号码' }]" -->
          <div class="display">
            <van-field
              v-model="commitData.captcha"
              label="验证码"
              placeholder="请输入验证码"
            />
            <div class="code">
              <van-button
                plain
                v-if="show60"
                size="mini"
                type="info"
                @click="getCaptcha"
                >点击获取验证码</van-button
              >
              <van-button plain v-if="!show60" size="mini" type="info"
                >{{ count }}秒后重新获取</van-button
              >
            </div>
          </div>
          <van-field
            v-model="setDefault"
            label="是否默认"
            :readonly="true"
            @click="openSetSelect"
          />
        </van-form>
      </div>
    </div>
    <div class="footer">
      <van-button
        round
        block
        type="info"
        size="normal"
        native-type="submit"
        @click="submitdata"
        >提交</van-button
      >
    </div>

    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        title=""
        :columns="cardTypeList"
        @confirm="onConfirm"
        @cancel="onCancel"
        :default-index="0"
      />
    </van-popup>
    <van-popup v-model="setShow" position="bottom">
      <van-picker
        show-toolbar
        title=""
        :columns="setList"
        @confirm="onSetConfirm"
        @cancel="onSetCancel"
        :default-index="0"
      />
    </van-popup>
  </div>
</template>

<script>
import { getCode, addPatient } from '@/api/api'
import { Toast } from 'vant'
export default {
  data() {
    return {
      commitData: {
        patientName: '',
        documentType: '身份证',
        idCard: '',
        phoneNumber: '',
        captcha: ''
      },
      setDefault: '是',
      active: 0,
      pattern: /^1[3456789]\d{9}$/,
      show: false,
      cardTypeList: ['身份证', '军官证', '护照'],
      setShow: false,
      setList: ['是', '否'],
      show60: true,
      count: '',
      timer: null,
      fileList: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    getCaptcha() {
      if (this.commitData.phoneNumber == '') {
        Toast('请输入手机号')
        return
      }
      getCode({ str: this.commitData.phoneNumber }).then(res => {
        // Toast(res.data)
        this.commitData.captcha = res.data
        this.beginTimer()
      })
    },
    beginTimer() {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show60 = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show60 = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    onFailed(errorInfo) {},
    submitdata() {
      let commit = this.commitData
      // patientName 姓名  idCard 身份证  phoneNumber 手机 captcha 验证码
      if (
        this.formV('empty', commit.patientName, '请输入姓名') &&
        this.formV('empty', commit.idCard, '请输入证件号码') &&
        this.formV('empty', commit.phoneNumber, '请输入手机号码') &&
        this.formV('tel', commit.phoneNumber, '请输入正确手机号码')
      ) {
        if (commit.documentType == '身份证') {
          if (!this.formV('IDCard', commit.idCard, '请输入正确身份证号码'))
            return
        }
      } else {
        return
      }
      if (!this.formV('empty', commit.captcha, '请输入验证码')) {
        return
      }
      if (this.setDefault == '是') {
        commit.mark = 0
      } else {
        commit.mark = 1
      }
      addPatient(commit).then(res => {
        if (res.code == 200) {
          Toast.success('创建成功')
          this.$loading.hide()
          if (this.$route.query.selectPeople == 'select') {
            this.$router.push({
              name: `bindPatient`,
              query: {
                commit: JSON.stringify(commit),
                selectQuery: JSON.stringify(this.$route.query)
              }
            })
          } else {
            this.$loading.hide()
            this.$router.push({
              name: `bindPatient`,
              query: {
                commit: JSON.stringify(commit)
              }
            })
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    formV(type, str, label) {
      label = label || ''
      let regular = ''
      switch (type) {
        // 空
        case 'empty':
          regular = /\S+/
          break
        // 数字验证
        case 'price':
          regular = /[0-9]*[1-9][0-9]*/
          break
        // 手机号
        case 'tel':
          regular = /^1\d{10}$/
          break
        // 身份证
        case 'IDCard':
          regular = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
          break
        // 邮箱
        case 'email':
          regular = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
          break
        default:
          return true
      }
      if (!regular.test(str) || str == null) {
        Toast.fail(label)
        return false
      } else {
        return true
      }
    },
    onConfirm(e) {
      this.commitData.documentType = e
      this.show = false
    },
    onCancel(e) {
      this.show = false
    },
    openSelect() {
      this.show = true
    },
    openSetSelect() {
      this.setShow = true
    },
    onSetConfirm(e) {
      this.setDefault = e
      this.setShow = false
    },
    onSetCancel(e) {
      this.setShow = false
    },
    afterRead(file) {
      this.$http
        .post(
          'https://api.weixin.qq.com/cv/ocr/idcard?access_token=ACCESS_TOCKEN',
          { img: file.file.content },
          { emulateJSON: true }
        )
        .then(success => {}) // error可以省略
    }
  }
}
</script>

<style scoped>
.main /deep/ .van-step--finish .van-step__circle {
  background-color: #3478f7;
}

.main /deep/ .van-step--finish .van-step__line {
  background-color: #3478f7;
}

.main /deep/ .van-step__icon--active {
  color: #3478f7 !important;
  font-size: 16px;
}

.main /deep/ .van-step__title--active {
  color: #3478f7 !important;
  font-size: 16px;
}

.main /deep/ .van-step__title {
  font-size: 16px;
}

.main /deep/ .van-button--mini {
  font-size: 16px;
}

.box {
  width: 100vw;
  height: 100vh;
  background-color: rgb(242, 248, 253);
}

.van-cell {
  font-size: 18px !important;
}

.step {
  background-color: #ffffff;
  border-top: 1px solid rgb(192, 233, 245);
  padding: 10px 0px;
}

.display {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}

.num {
  border-radius: 100px;
  width: 17px;
  height: 17px;
  text-align: center;
  line-height: 17px;
  background-color: #ffffff;
  border: 1px solid rgb(112, 112, 112);
  color: rgb(112, 112, 112);
  margin-right: 3px;
}

.line {
  width: 40px;
  margin: 0px 10px;
  height: 1px;
  background-color: rgb(198, 198, 198);
}

title {
  color: rgb(112, 112, 112);
}

.active .num {
  background-color: rgb(8, 112, 253);
  color: #ffffff;
  border: 1px solid rgb(112, 112, 112);
}

.active .title {
  color: rgb(8, 112, 253);
}

.line {
  width: 40px;
  margin: 0px 10px;
  height: 1px;
  background-color: rgb(198, 198, 198);
}

title {
  color: rgb(112, 112, 112);
}

.active .num {
  background-color: rgb(8, 112, 253);
  color: #ffffff;
  border: 1px solid rgb(112, 112, 112);
}

.active .title {
  color: rgb(8, 112, 253);
}

.idcode {
  margin: 20px 0px;
  background-color: #ffffff;
  font-size: 18px;
  padding: 0px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.idcode p {
  color: rgb(113, 113, 113);
}

.idcode img {
  width: 100px;
  height: 60px;
}

.form {
  margin-top: 20px;
}

.code {
  width: 200px;
}

.code /deep/ button {
  border: 1px solid #ffffff;
}

.footer {
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  background-color: #ffffff;
}

.footer button {
  width: calc(100% - 40px);
  margin: 10px 20px 10px 20px;
  height: 52px;
  font-size: 18px;
}
</style>
